import { Check } from '@mui/icons-material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import { Chip, Tooltip, Typography, Zoom } from '@mui/material';
import { GridColDef, GridRenderCellParams, GridRowParams } from '@mui/x-data-grid-premium';
import { baseCell } from 'components/cells/BaseCell';
import { booleanCell } from 'components/cells/BooleanCell';
import { filterOperators, dateFilterOperators, booleanFilterOperators } from 'components/enhanced';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const InventoryCheckArchiveColumns = (service: any, refresh: any): GridColDef[] => {
  const { t } = useTranslation();
  return [
    {
      field: 'notes',
      headerName: t(`global.description`),
      width: 350,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      width: 350,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'partial',
      headerName: t(`global.partial`),
      width: 100,
      type: 'boolean',
      renderCell: booleanCell(t)
    },
    {
      field: 'date',
      headerName: t(`global.date`),
      width: 200,
      type: 'date',
      valueGetter: ({ value }) => (value ? new Date(value) : null),
      filterOperators: dateFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'created_by',
      headerName: t(`global.created_by`),
      width: 150,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'is_valid',
      headerName: t(`global.status`),
      width: 100,
      type: 'boolean',
      filterOperators: booleanFilterOperators,
      renderCell: (params: GridRenderCellParams<any>) =>
        !params.row.open && (
          <Tooltip
            TransitionComponent={Zoom}
            arrow
            title={
              !params.row.is_valid &&
              params.row.errors.length > 0 && (
                <React.Fragment>
                  <Typography fontSize={12} color="inherit">
                    <ul>
                      {params.row.errors.map((error, i) => (
                        <li key={i}>- {error}</li>
                      ))}
                    </ul>
                  </Typography>
                </React.Fragment>
              )
            }>
            <Chip
              sx={{ background: 'transparent' }}
              icon={params.value ? <Check color="success" /> : <PriorityHigh color="warning" />}
            />
          </Tooltip>
        )
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        return [
          {
            label: 'Reopen',
            icon: <LockOpenIcon />,
            onClick: () => {
              service.reopen(params.row.id).then(() => {
                refresh.current();
              });
            }
          }
        ];
      }
    } as GridColDef
  ];
};
